import { useZeroFoods } from "@animus/frontend-features/nutrition/foods";

import { AdminFoods } from "./admin-foods.tsx";

function AdminFoodsConnected() {
  const { foods, isLoading, error } = useZeroFoods({ limit: 100 });

  return <AdminFoods error={error} foods={foods} isLoading={isLoading} />;
}

export { AdminFoodsConnected };
